/**
 * Web Style Import
 *
 */

import './style/dnb-tooltip.scss'
